export const enqueueRhodeQueue = (queue, message, urgent = false) => {
  const current = Array.isArray(queue) ? queue : [];
  const isStructured = Boolean(message && typeof message === "object");
  const text = String(isStructured ? message.text : message || "").trim();
  if (!text) return [...current];
  const entry = isStructured ? { ...message, text } : text;
  return urgent ? [entry, ...current] : [...current, entry];
};
